import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { CountUp } from 'countup.js';

function playCounters(parent) {
  const list = parent.querySelector('.numbers-banner__list');
  list.classList.add('is-playing');

  if (window.innerWidth < 768) return;

  const counters = parent.querySelectorAll('.numbers-banner__counter[data-counter]');
  counters.forEach((counterElement) => {
    const count = new CountUp(counterElement, counterElement.dataset.counter, {
      separator: '',
      decimal: '',
      useEasing: false,
      duration: counterElement.dataset.counterDuration ?? 1,
      startVal: counterElement.dataset.counterStart ?? 1,
    });
    if (!count.error) count.start();
  });
}

function init(parent) {
  const swiperElement = parent.querySelector('.numbers-banner__swiper');
  new Swiper(swiperElement, {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 1,
    //init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      450: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      768: {
        enabled: false,
      },
    },
  });

  setTimeout(() => playCounters(parent), 800);
}

export function numbersBanner(selector = '.numbers-banner') {
  document.querySelectorAll(selector).forEach((element) => init(element));
}
